import { FSetupFetchActionType, FSetupFetchFurniturePayload } from '../types/index.js';

import { useFetchMethodResolver } from './useFetchMethodResolver.js';
import { useResolver } from './useResolver.js';

export interface FurnitureHookResolver {
  /**
   * Returns the url for the given key
   */
  (input: number): FSetupFetchFurniturePayload;
  /**
   * Returns an array of urls for the given keys
   */
  (input: number[]): FSetupFetchFurniturePayload[];
}

export const useFurnitureResolver: FurnitureHookResolver = (id: any) =>
  useResolver(useFetchMethodResolver(), id, FSetupFetchActionType.Furniture) as any;
